import { unit_type } from "../../services/api/api"
import rs from '../../assets/images/logo/rs.svg'

type IUnits = {
  [k in unit_type]: string;
};
export const Units:IUnits= {
    'Area':'²م' ,
    'Length':'م',
    'Piece':'حبة'
}

export const money_unit=<img 
    src={rs} 
    alt="SAR" 
    style={{ height: '0.49em', verticalAlign: 'middle', margin: '0em 0em 0 0.2em' }} 
  />